sharpen-wizard-header {
  nav {
    display: flex;

    .sharpen-icon {
      font-size: 14pt;
      vertical-align: 4px;
    }

    h1 { flex: 1; text-align: center; }
    
    // When the header has a back button, ensure the title stays centered by
    // applying some padding on the opposite side.
    a + h1 { padding-right: 14pt; }
  }
}